var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ModalInternal } from "./ModalInternal";
import { ModalRoot } from "./ModalRoot";
export var Modal = function (props) { return (_jsx(ModalRoot, { children: _jsx(ModalInternal, __assign({}, props)) })); };
